// extracted by mini-css-extract-plugin
export default {"auth":"Body_auth__xLXIC","image":"Body_image__CNYP-","title":"Body_title__YJsZX","description":"Body_description__2UNKE"};